import { interval, Observable, of } from 'rxjs';
import { catchError, filter, map, take, timeout } from 'rxjs/operators';

export function loadScript(url: string, id: string): Observable<boolean> {
  return new Observable((sub) => {
    const scriptTag = document.getElementById(id) as HTMLScriptElement;
    if (scriptTag) {
      sub.next(true);
      sub.complete();
    } else {
      const script: HTMLScriptElement = document.createElement('script');
      script.id = id;
      script.src = url;
      script.onload = () => {
        sub.next(true);
        sub.complete();
      };
      script.onerror = (err) => {
        sub.error(err);
      };
      document.head.appendChild(script);
    }
  });
}

export function waitForGlobal(key: string, maxWaitMs = 3000) {
  return interval(50).pipe(
    map(() => key in window),
    filter(Boolean),
    take(1),
    timeout(maxWaitMs),
    catchError(() => of(false))
  );
}
